import React from 'react';
import moment from 'moment';
import { Tooltip } from 'antd';
import { CustomIcon, MoreTags } from 'datastake-daf/dist/components';
import { Link } from 'react-router-dom';

const cols = (t, module = 'pme', view, show = 'show', activeFilters = {}, push, activeTab) => {
  const cols = [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'datastakeId',
      show: true,
      ellipsis: true,
      search: true,
      sorter: () => 0 + 0,
      publication: true,
      width: 160,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return v;
      }
    },
    {
      title: t(['pictures', 'documents'].includes(view) ? 'Title' : 'Name'),
      dataIndex: 'title',
      key: 'title',
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
      sorter: () => 0 + 0,
      show: true,
    },
    {
      title: t('Type'),
      dataIndex: 'type',
      key: 'type',
      show: ['initiatives'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Category'),
      dataIndex: 'category',
      key: 'category',
      show: ['locations', 'stakeholders'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Sub Category'),
      dataIndex: 'subCategory',
      key: 'subCategory',
      show: ['stakeholders'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Country'),
      dataIndex: 'country',
      key: 'country',
      show: ['locations', 'stakeholders'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Province'),
      dataIndex: 'adminLevel1',
      key: 'adminLevel1',
      show: ['locations'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Territory'),
      dataIndex: 'adminLevel2',
      key: 'adminLevel2',
      show: ['locations'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Age'),
      dataIndex: 'age',
      key: 'age',
      show: ['victims'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Gender'),
      dataIndex: 'gender',
      key: 'gender',
      show: ['victims'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Incident Count'),
      dataIndex: 'incidentCount',
      key: 'incidentCount',
      show: ['victims'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Assistance Count'),
      dataIndex: 'assistedCount',
      key: 'assistedCount',
      show: ['victims'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Primary organisation'),
      dataIndex: 'primaryOrg',
      key: 'primaryOrg',
      show: ['initiatives'].includes(view),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Scope of the initiative'),
      dataIndex: 'intiativesScope',
      key: 'intiativesScope',
      show: ['initiatives'].includes(view),
      render: (val) => Array.isArray(val) ? <MoreTags values={val} /> : val,
      ellipsis: true,
    },
    {
      title: t('Start Date'),
      dataIndex: 'startDate',
      key: 'startDate',
      show: ['initiatives'].includes(view),
      width: 125,
      render: (date, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        const title = date ? moment(date).format('DD MMM YYYY') : '--';
        return <Tooltip title={title}>{title}</Tooltip>
      },
      ellipsis: true,
    },
    {
      title: t('End Date'),
      dataIndex: 'endDate',
      key: 'endDate',
      show: ['initiatives'].includes(view),
      width: 125,
      render: (date, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        const title = date ? moment(date).format('DD MMM YYYY') : '--';
        return <Tooltip title={title}>{title}</Tooltip>
      },
      ellipsis: true,
    },
    {
      title: t('Date'),
      dataIndex: 'date',
      key: 'date',
      show: ['pictures', 'documents', 'victims'].includes(view),
      width: 125,
      render: (date, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        const title = date ? moment(date).format('DD MMM YYYY') : '--';
        return <Tooltip title={title}>{title}</Tooltip>
      },
      ellipsis: true,
    },
    {
      title: t('Source'),
      dataIndex: 'source',
      key: 'source',
      show: activeTab !== 'ownData',
      render: (date, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return all?.authorId?.name || '--';
      },
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'actions',
      width: 60,
      show: true,
      key: 'actions',
      render: (_, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }

        let redView = view;

        if (redView === 'events') {
          redView = 'event';
        }

        if (redView === 'locations') {
          redView = 'location';
        }

        if (redView === 'stakeholders') {
          redView = 'stakeholder';
        }

        return (
          <Link to={`/app/${module}/view/${redView}/${val.id}`}>
            <CustomIcon width={15} height={15} color="#6C737F" name="Link" />
          </Link>
        );
      }
    },
  ];

  return cols.filter(c => c.show);
}

export default cols;
